<template>
  <div class="dialog-wrap">
    <el-dialog title="学制"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               :modal-append-to-body="false"
               @open="open"
               width="80%">
      <div class="values">
        <div style="display:flex;justify-content: space-between; min-height:70px">
          <el-form class="search-wrap"
                   ref="searchForm"
                   :inline="true"
                   :model="query">
            <el-form-item label="年份"
                          prop="year">
              <el-select v-model="year"
                         clearable
                         style="width:90px;marginLeft:10px"
                         placeholder="请选择"
                         @change="fetchList(true)">
                <el-option label="2027年"
                           value="2027"></el-option>
                <el-option label="2026年"
                           value="2026"></el-option>
                <el-option label="2025年"
                           value="2025"></el-option>
                <el-option label="2024年"
                           value="2024"></el-option>
                <el-option label="2023年"
                           value="2023"></el-option>
                <el-option label="2022年"
                           value="2022"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="院校名称"
                          prop="college_name">
              <el-select v-model="college_keyword"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         clearable
                         @change="fetchList(true)">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学院"
                          prop="reamrk">
              <el-select v-model="apply_academy"
                         placeholder="请选择院校"
                         clearable
                         filterable
                         @change="academyChange"
                         style="width: 100%;">
                <el-option v-for="(item,index) in academyList"
                           :key="index"
                           :label="`（${item.code}）${item.name}`"
                           :value="{ value: item.code, label: item.name}">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业"
                          prop="reamrk">
              <el-select v-model="apply_major"
                         placeholder="请选择专业"
                         clearable
                         filterable
                         @change="majorChange"
                         style="width: 100%;">
                <el-option v-for="(item,index) in majorList"
                           :key="index"
                           :label="`（${item.code}）${item.name}`"
                           :value="{ value: item.code, label: item.name}">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div class="btBox">
            <el-button plain
                       style="marginRight:10px"
                       @click="handleDownload"
                       type="primary">下载模板</el-button>
            <input @change="upload"
                   type="file"
                   name="photoImg"
                   id="getFile"
                   style="display:none;"
                   class="upload-input" />
            <label for="getFile"
                   class="fileStyle">导入</label>
            <el-button class="button"
                       style="marginLeft:10px"
                       @click="secondarAdd"
                       type="primary">新建</el-button>
          </div>
        </div>
        <el-table class="table"
                  :data="results"
                  @selection-change="handleSelectionChange"
                  border
                  style="width: 100%">
          <el-table-column type="selection"
                           width="50"
                           align="center"
                           fixed="left">
          </el-table-column>
          <el-table-column type="index"
                           label="序号"
                           width="60"
                           align="center">
          </el-table-column>
          <el-table-column label="年份"
                           width="100px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmt(scope.row.year) }}
            </template>
          </el-table-column>
          <el-table-column label="院校"
                           align="center"
                           show-overflow-tooltip
                           width="140px">
            <template slot-scope="scope">
              {{ fmt(scope.row.college_name) }}
            </template>
          </el-table-column>
          <el-table-column label="学院"
                           width="220px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmtCodeName(scope.row.academy_code, scope.row.academy_name, '(', ')') }}
            </template>
          </el-table-column>
          <el-table-column label="专业"
                           align="center"
                           width="220px"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmtCodeName(scope.row.major_code, scope.row.major_name, '[', ']') }}
            </template>
          </el-table-column>
          <el-table-column label="方向"
                           width="220px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmtCodeName(scope.row.direction_code, scope.row.direction_name, '(', ')') }}
            </template>
          </el-table-column>
          <el-table-column label="学习方式"
                           width="100px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmtEnrolType(scope.row.enrol_type) }}
            </template>
          </el-table-column>
          <el-table-column label="学制"
                           width="160px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmt(scope.row.learn_span) }}
            </template>
          </el-table-column>
          <el-table-column label="最新更新人"
                           width="120px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmt(scope.row.last_update_admin_nickname) }}
            </template>
          </el-table-column>
          <el-table-column label="更新时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{ fmtTime(scope.row.update_time) }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="secondarEdit(scope.row)">编辑</el-link> |
              <el-link type="danger"
                       :underline="false"
                       @click="secondarDelele(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <div>
          <el-button size="mini"
                     type="danger"
                     @click="handleToDeleteAll()">批量删除</el-button>
        </div>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
      <AddLearnSpan :visible="addVisible"
                    @close="close"
                    :detail="detail"
                    :rowId="rowId"
                    @submit="fetchList(true)"
                    :title="title"></AddLearnSpan>
    </el-dialog>
  </div>
</template>

<script>
import AddLearnSpan from '@/components/dialog/admission/addLearnSpan'
import {
  learnSpanList,
  learnSpanDelete,
  learnSpanlmport,
} from '@/api/admission'
import { collegeMajorList, academyList } from '@/api/common'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    learnSpanDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    year: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    learnSpanDetail(val) {
      this.detail = val
      this.$set(this.apply_major, 'value', val.major_code)
      this.college_keyword = val.college_code
    },
  },
  components: {
    AddLearnSpan,
  },
  data() {
    return {
      detail: {},
      dialogVisible: false,
      addVisible: false,
      title: '',
      rowId: null,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      chooseList: [],
      majorList: [],
      academyList: [],
      apply_major: { value: '', label: '' },
      apply_academy: {},
      college_keyword: '',
    }
  },
  methods: {
    fmt(val) {
      if (val === null || val === undefined) return '--'
      const s = String(val).trim()
      return s === '' ? '--' : val
    },
    fmtCodeName(code, name, left, right) {
      const c = String(code || '').trim()
      const n = String(name || '').trim()
      if (!c && !n) return '--'
      return (c ? `${left}${c}${right}` : '') + n
    },
    fmtEnrolType(val) {
      if (val === null || val === undefined) return '--'
      const s = String(val).trim()
      if (s === '') return '--'
      const map = { 1: '全日制', 2: '非全日制' }
      return map[Number(val)] || '--'
    },
    fmtTime(time, format) {
      if (time === null || time === undefined) return '--'
      const s = String(time).trim()
      if (s === '') return '--'
      return this.$moment(time).format(format || 'YYYY.MM.DD HH:mm')
    },
    // 学院下拉变化
    academyChange() {
      this.fetchList(true)
    },
    // 专业下拉变化
    majorChange() {
      this.fetchList(true)
    },
    // 专业下拉数据
    Majorists() {
      collegeMajorList({
        college_code: this.detail.college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list
      })
    },
    // 学院下拉数据
    getAcademyList() {
      academyList({
        college_code: this.detail.college_code,
        isPaging: 0,
      }).then((res) => {
        this.academyList = res.list
      })
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm('确定要删除这些信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = this.chooseList.map((v) => {
          return v.id
        })
        learnSpanDelete({ ids }).then(() => {
          this.$message.success('删除成功')
          this.fetchList()
        })
      })
    },
    open() {
      this.fetchList()
      this.Majorists()
      this.getAcademyList()
    },
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      params.year = this.year
      params.college_code = this.college_keyword
      params.academy_code = this.apply_academy.value
      params.major_code = this.apply_major.value
      learnSpanList(params).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
    },
    // 下载导入模板
    handleDownload() {
      let url =
        'https://upload.kaoyanbox.net/1c556a08b397c70034bbd6c6da19f088.xlsx'
      let filename = '学制导入示例文件.xlsx'
      var ajax = new XMLHttpRequest()
      ajax.open('GET', url, true)
      ajax.responseType = 'blob'
      ajax.onload = (e) => {
        let res = e.target.response
        let blob = new Blob([res], { type: res.type })
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, filename)
        } else {
          const href = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = href
          a.download = filename
          a.click()
          URL.revokeObjectURL(a.href)
        }
      }
      ajax.send()
    },
    // 导入
    upload(e) {
      const file = e.target.files[0]

      if (file) {
        /******  此处为上传服务器 start   ******/
        let formData = new FormData()
        formData.append('file', file)

        learnSpanlmport(formData).then((res) => {
          if (res == null) {
            this.$message.success(`导入成功`)
            this.fetchList(true)
          }
        })
      }
    },
    handleClose() {
      this.apply_major = {}
      this.apply_academy = {}
      this.chooseList = []
      this.$emit('close')
      this.query.pageIndex = 1
    },
    close() {
      this.addVisible = false
    },
    secondarEdit(row) {
      this.rowId = row.id
      this.addVisible = true
      this.title = '编辑学制'
    },
    secondarAdd() {
      this.addVisible = true
      this.title = '新建学制'
    },
    secondarDelele(row) {
      let id = {
        ids: [row.id],
      }
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定删除',
        type: 'warning',
      }).then(() => {
        learnSpanDelete(id).then(() => {
          this.$message.success('操作成功')
          this.fetchList()
        })
      })
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
  },
}
</script>

<style lang="less" scoped>
.fileStyle {
  position: relative;

  margin-right: 5px;
  border-radius: 1px;
  padding: 6px 15px;
  color: #999999;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #999999;
}
::v-deep .el-upload-list {
  display: none !important;
}
.btBox {
  position: relative;
}
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.footer {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
</style>
